"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDetailedStatistics = exports.reduceStats = void 0;
const shift_detailed_statistics_1 = require("@app/request/shift-detailed-statistics");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const reduceStats = (acc, curr) => ({
    customAttributes: [
        ...(acc.customAttributes ?? []),
        ...(curr.customAttributes ?? []),
    ],
    date: curr.date,
    holidayMinutes: (acc.holidayMinutes ?? 0) + (curr.holidayMinutes ?? 0),
    nightMinutes: (acc.nightMinutes ?? 0) + (curr.nightMinutes ?? 0),
    overTimeAgreedMinutes: (acc.overTimeAgreedMinutes ?? 0) + (curr.overTimeAgreedMinutes ?? 0),
    overTimeMinutes: (acc.overTimeMinutes ?? 0) + (curr.overTimeMinutes ?? 0),
    overTimeOrderedMinutes: (acc.overTimeOrderedMinutes ?? 0) + (curr.overTimeOrderedMinutes ?? 0),
    overTimePaidMinutes: (acc.overTimePaidMinutes ?? 0) + (curr.overTimePaidMinutes ?? 0),
    overTimePaidTOILMinutes: (acc.overTimePaidTOILMinutes ?? 0) + (curr.overTimePaidTOILMinutes ?? 0),
    overTimeTotalMinutes: (acc.overTimeTotalMinutes ?? 0) + (curr.overTimeTotalMinutes ?? 0),
    overTimeUnpaidMinutes: (acc.overTimeUnpaidMinutes ?? 0) + (curr.overTimeUnpaidMinutes ?? 0),
    positions: [...(acc.positions ?? []), ...(curr.positions ?? [])],
    saturdayMinutes: (acc.saturdayMinutes ?? 0) + (curr.saturdayMinutes ?? 0),
    standByActivityMinutes: (acc.standByActivityMinutes ?? 0) + (curr.standByActivityMinutes ?? 0),
    standByMinutes: (acc.standByMinutes ?? 0) + (curr.standByMinutes ?? 0),
    sundayMinutes: (acc.sundayMinutes ?? 0) + (curr.sundayMinutes ?? 0),
    totalMinutes: (acc.totalMinutes ?? 0) + (curr.totalMinutes ?? 0),
    weekDayMinutes: (acc.weekDayMinutes ?? 0) + (curr.weekDayMinutes ?? 0),
    weekEndMinutes: (acc.weekEndMinutes ?? 0) + (curr.weekEndMinutes ?? 0),
    workMinutes: (acc.workMinutes ?? 0) + (curr.workMinutes ?? 0),
});
exports.reduceStats = reduceStats;
const useDetailedStatistics = ({ shouldLoadDetailedStatistics = true, shiftId,
// fallback,
 }) => {
    const [detailedStatistics, setDetailedStatistics] = react_1.default.useState();
    react_1.default.useEffect(() => {
        if (!shouldLoadDetailedStatistics)
            return;
        if ((0, util_1.isUndefined)(shiftId))
            return;
        const action = async () => {
            const res = await (0, shift_detailed_statistics_1.requestDetailedStatistics)({ shiftId });
            if ((0, util_1.isUndefined)(res)) {
                if (detailedStatistics !== undefined) {
                    setDetailedStatistics(undefined);
                }
                return;
            }
            setDetailedStatistics(res.reduce(exports.reduceStats));
        };
        action();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shiftId, shouldLoadDetailedStatistics]);
    return detailedStatistics;
};
exports.useDetailedStatistics = useDetailedStatistics;
